module.exports = `${require.publicPath}southbay-dark-sm.be11810d.webp`;